import React from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBookOpen, FiTarget, FiUserPlus, FiUpload, FiPieChart, FiArrowRight } = FiIcons;

const actions = [
  { label: 'Launch Campaign', icon: FiBookOpen, path: '/campaigns' },
  { label: 'New Phishing Sim', icon: FiTarget, path: '/phishing' },
  { label: 'Add Learner', icon: FiUserPlus, path: '/learners' },
  { label: 'Upload Content', icon: FiUpload, path: '/library' },
  { label: 'View Reports', icon: FiPieChart, path: '/reports' },
];

const QuickActions = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      <div className="px-5 py-4 border-b border-slate-100">
        <h3 className="text-sm font-semibold text-slate-800">Quick Actions</h3>
      </div>
      <div className="p-3 space-y-1">
        {actions.map(a => (
          <button key={a.label} onClick={() => navigate(a.path)}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-slate-50 transition-colors text-left group">
            <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 bg-slate-100 text-slate-600`}>
              <SafeIcon icon={a.icon} className="text-[15px]" />
            </div>
            <span className="text-sm font-medium text-slate-700 flex-1">{a.label}</span>
            <SafeIcon icon={FiArrowRight} className="text-slate-300 group-hover:text-slate-500 text-xs transition-colors" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;